import { Box, Card, useTheme } from '@material-ui/core'
import React from 'react'
import Inbond7512AddForm from './Inbond7512AddForm'
import Stepper from '../../../components/aciacehighway/Stepper'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import ACEHighwayInbond7512TranslationText from '../contexts/ACEHighwayInbond7512TranslationText'

function AddPage({ history, showNotification, onSetLoading }) {
  const theme = useTheme()
  const translatedTextsObject = ACEHighwayInbond7512TranslationText()

  return (
    <Card>
      <Stepper steps={[translatedTextsObject.createInBond7512]} activeStep={0} />
      <Box
        padding={2}
        style={{ backgroundColor: theme.palette.background.sectionOddBg }}
      >
        <Inbond7512AddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => console.log('submit success')}
          onSetLoading={onSetLoading}
        />
      </Box>
    </Card>
  )
}

export default withFormState(AddPage)
